import { render, staticRenderFns } from "./BillingDataAccess.vue?vue&type=template&id=884519ba&scoped=true&"
import script from "./BillingDataAccess.vue?vue&type=script&lang=js&"
export * from "./BillingDataAccess.vue?vue&type=script&lang=js&"
import style0 from "./BillingDataAccess.vue?vue&type=style&index=0&id=884519ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884519ba",
  null
  
)

export default component.exports